
import {
  Box, Grid, Typography,
} from '@mui/material';

import { IUserDetailPage } from '../../Interface';

import LogoUserTop from '../../../../Assets/lead_120.png';
import FieldPage from './_field';
function UserDetailHeaderPage(props: IUserDetailPage) {

  return (
    <Box id="UserDetailHeaderPage" key="UserDetailHeaderPage" className="UserDetailHeaderRoot">
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Typography component="div" align="left" className='UserDetailHeaderBox'>
            <Box className='UserDetailHeaderImgLogoBox'>
              <img
                src={`${LogoUserTop}`}
                srcSet={`${LogoUserTop}`}
                alt="Logo User"
                loading="lazy"
                className='UserDetailHeaderImgLogo'
              />
            </Box>
            <Box className='UserDetailHeaderTitleBox'>
              <Typography component="div" align="left">
                <span className='UserDetailHeaderSubTitle'>Usuário</span>
              </Typography>
              <Typography component="div" align="left">
                <span className='UserDetailHeaderTitle'>{props.item.name}</span>
              </Typography>
            </Box>
            <Box className='UserDetailHeaderButtonBox'>
              <Typography component="div" align="right">
              </Typography>
            </Box>
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Typography component="div" align="center" className='UserDetailHeaderInfoBox'>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                <FieldPage label={'CPF/CNPJ'} value={props.item.documentnumber || ''} />
              </Grid>
              <Grid item xs={6} sm={3} md={3} lg={3} xl={3}>
                <FieldPage label={'Ativo'} value={props.item.active ? 'Sim' : 'Não'} />
              </Grid>
            </Grid>
          </Typography>
        </Grid>
      </Grid>
    </Box>
  )
}

export default UserDetailHeaderPage;
